import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
})
export class FormErrorComponent implements OnInit {
  @Input() classNames: string = '';
  @Input() htmlFor: string = '';
  constructor() {}

  ngOnInit(): void {}
}
